export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-fill text-xl text-primary-500"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">网红爆料</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              全网最全网红爆料视频平台，每日更新热门网红黑料视频、
              内幕实锤解说及瓜视频大揭秘，吃瓜视频一网打尽。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">深度爆料</a>
              </li>
              <li>
                <a href="#media" onClick={(e) => handleScroll(e, '#media')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">热门视频</a>
              </li>
              <li>
                <a href="#ranking" onClick={(e) => handleScroll(e, '#ranking')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">热搜榜单</a>
              </li>
              <li>
                <a href="#topics" onClick={(e) => handleScroll(e, '#topics')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">热门话题</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">专题合集</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">直播带货翻车</a>
              </li>
              <li>
                <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">网红人设崩塌</a>
              </li>
              <li>
                <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">MCN机构内幕</a>
              </li>
              <li>
                <a href="#index" onClick={(e) => handleScroll(e, '#index')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">短视频造假实锤</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">投稿爆料</a>
              </li>
              <li>
                <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">常见问题</a>
              </li>
              <li>
                <a href="#app" onClick={(e) => handleScroll(e, '#app')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">APP下载</a>
              </li>
              <li>
                <a href="#about" onClick={(e) => handleScroll(e, '#about')} className="text-xs text-background-400 hover:text-accent-400 transition-colors">关于我们</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-background-100 mb-4 text-center">合作伙伴</h4>
          <p className="text-xs text-background-500 text-center">诚邀各大内容平台、媒体机构合作，共创网红行业内容生态</p>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2023-2026 网红爆料 版权所有 | 每日更新热门网红爆料合集
          </p>
          <div className="flex items-center gap-4">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 cursor-pointer hover:bg-background-700 transition-colors">
              <i className="ri-weibo-line text-sm text-background-300"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 cursor-pointer hover:bg-background-700 transition-colors">
              <i className="ri-wechat-line text-sm text-background-300"></i>
            </span>
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 cursor-pointer hover:bg-background-700 transition-colors">
              <i className="ri-bilibili-line text-sm text-background-300"></i>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}